import { createContext, useContext } from 'react';
export const ProductMediaLightBoxContext = createContext({});
export const useProductMediaLightBox = () => {
    const context = useContext(ProductMediaLightBoxContext);
    return context;
};
